<template>
    <div>
        <h1>Pontuação</h1>
    </div>
</template>
<script>
export default {
    name:'Score'
}
</script>